import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BatchImportModel } from '@data-layer/models/common';
import { BatchImportService } from '@shared/batch-import-mutual/services';

@Component({
  selector: 'batch-process-error-notification',
  templateUrl: './batch-process-error-notification.component.html',
  styleUrls: ['./batch-process-error-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchProcessErrorNotificationComponent {
  @Input() public batchItem: BatchImportModel;

  constructor(private batchImportService: BatchImportService) {}

  public onReload(): void {
    this.batchImportService.openSidebar(this.batchItem);
  }
}
